import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductTab } from '../core';

@Injectable({
  providedIn: 'root'
})
export class ProductTabsService {
  private _tabs: BehaviorSubject<Map<string, ProductTab>> = new BehaviorSubject<Map<string, ProductTab>>(new Map<string, ProductTab>());

  get tabs(): Observable<ProductTab[]> {
    return this._tabs.asObservable().pipe(map((tabsMap: Map<string, ProductTab>) => Array.from(tabsMap, ([_, value]) => ({ ...value }))));
  }

  removeTabs(tabIds: string[]): void {
    const tabs = this._tabs.getValue();
    tabIds.forEach((id) => tabs.delete(id));
    this._tabs.next(tabs);
  }

  addTabs(tabs: ProductTab[]): void {
    const allTabs = this._tabs.getValue();
    tabs.forEach((tab) => allTabs.set(tab.id, tab));
    this._tabs.next(allTabs);
  }

  removeAllTabs(): void {
    this._tabs.next(new Map<string, ProductTab>());
  }

  setTabName(id: string, name: string): void {
    const tabs = this._tabs.getValue();
    const tab = tabs.get(id);
    tabs.set(id, { ...tab, name });
    this._tabs.next(tabs);
  }
}
